// 一个vue3插件，用于注册全局使用的组件和指令

import click from '@/plugins/vue/click';
import show from '@/plugins/vue/show';
import itemContainer from '@/components/itemContainer.vue';
import mItemContainer from '@/components/mItemContainer.vue';   // 移动端组件
import commonItem from '@/components/commonItem.vue';
import mCommonItem from '@/components/mCommonItem.vue';   // 移动端组件

import tRow from '@/components/tRow.vue';

import ruleBtn from '@/components/ruleBtn.vue';
import toast from '@/components/toast.vue';
import toastItem from '@/components/toastItem.vue';
import bgContainer from '@/components/bgContainer.vue';
import Button from '@/components/Button.vue';
// import copyBtn from '@/components/copyBtn.vue';
import dialog from '@/components/dialog.vue';
import Image from '@/components/Image.vue';
import Select from '@/components/Select.vue';
import Table from '@/components/Table.vue';
import Input from '@/components/Input.vue';
import mInput from '@/components/mInput.vue';   // 移动端组件

import Share from '@/components/Share.vue';
import mShare from '@/components/mShare.vue';   // 移动端组件
import hScroll from '@/components/hScroll.vue';

import Pagination from '@/components/Pagination.vue';

import Footer from '@/components/Footer.vue';

// 添加全局函数
import record from '@/utils/log';
const plugin = {
  install(app) {
    app.component('commonItem', commonItem);
    app.component('mCommonItem', mCommonItem);
    app.component('itemContainer', itemContainer);
    app.component('mItemContainer', mItemContainer);

    app.component('tRow', tRow);
    
    app.component('ruleBtn', ruleBtn);
    app.component('toast', toast);
    app.component('toastItem', toastItem);
    app.component('TxBg', bgContainer);
    app.component('TxBtn', Button);
    // app.component('copyBtn', copyBtn);
    app.component('TxDialog', dialog);
    app.component('TxImage', Image);
    app.component('TxSelect', Select);
    app.component('TxTable', Table);
    
    app.component('TxInput', Input);
    app.component('TxMInput', mInput);
    
    app.component('TxShare', Share);
    app.component('TxMShare', mShare);

    app.component('TxPagination', Pagination);
    app.component('TxFooter', Footer);
    app.component('TxHScroll', hScroll);
    
    
    
    app.directive('click', click);
    app.directive('look', show);
    app.config.errorHandler = (err, instance, info) => {
      if (import.meta.env.PROD) {
        record({
          name: import.meta.env.VITE_NAME,
          message: err.message,
          stack: err.stack ? err.stack : '',
          instance: instance.$options.name,
          info,
        });
      } else {
        console.error('报错:', err, instance, info);
      }
    };
  },
};

export default plugin;
